import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from "../core/Api";

const useStyles = makeStyles(() => ({
  flexCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    "&.spacing": {
      marginLeft: ({ scaleFactor }) => -120 / scaleFactor,
    },
  },
  container: {
    position: "relative",
  },
  barImage: {
    width: "100%",
    position: "absolute",
    bottom: 0,
    zIndex: 3,
    left: ({ scaleFactor }) => -40 / scaleFactor,
  },
  floor: {
    position: "absolute",
    bottom: 0,
    zIndex: 4,
    left: ({ scaleFactor }) => -32 / scaleFactor,
  },
  securingBar: {
    position: "absolute",
    top: ({ scaleFactor }) => -128 / scaleFactor,
    zIndex: -1,
  },
  leftBullBar: {
    position: "absolute",
    bottom: ({ scaleFactor }) => -32 / scaleFactor,
    left: ({ scaleFactor }) => -48 / scaleFactor,
    zIndex: 5,
  },
  rightBullBar: {
    position: "absolute",
    bottom: ({ scaleFactor }) => -32 / scaleFactor,
    right: ({ scaleFactor }) => -56 / scaleFactor,
    zIndex: 5,
  },
  centerBullBar: {
    position: "absolute",
    bottom: ({ scaleFactor }) => -32 / scaleFactor,
    zIndex: 2,
    left: 0,
  },
  leftFrame: {
    position: "absolute",
    left: ({ scaleFactor }) => 16 / scaleFactor,
    zIndex: 6,
    "&.bottomLayer": {
      zIndex: -1,
    },
  },
  rightFrame: {
    position: "absolute",
    right: 0,
    zIndex: 6,
    top: 0,
    "&.bottomLayer": {
      zIndex: -1,
    },
  },
}));

const TopView2D = (data, { ...props }) => {
  const selectedHeightOptions = useSelector(
    (state) => state.Configuration.artusComponentOptions.find((opt) => opt.key === "height").options
  );

  const id = get(data, "data.id", null);
  const currentHeightIdentifier = get(data, "data.height", 2000);
  const nextFieldHeightIdentifier = get(data, "nextField.height", 2000);
  const nextFieldHeight = Number(get(data, "nextField.height", 2000).match(/\d+/));
  const currentHeight = Number(get(data, "data.height", 2000).match(/\d+/));
  const selectedHeightIdentifier =
    nextFieldHeight > currentHeight ? nextFieldHeightIdentifier : currentHeightIdentifier;
  const selectedHeightOption = selectedHeightOptions.find(
    (option) => option.identifier === selectedHeightIdentifier
  );
  const currentSelectedHeightOption = selectedHeightOptions.find(
    (option) => option.identifier === currentHeightIdentifier
  );
  const currentSelectedHeightOptionAttributes = currentSelectedHeightOption
    ? currentSelectedHeightOption.attributes || []
    : [];
  const selectedHeightAttributes = selectedHeightOption ? selectedHeightOption.attributes || [] : [];
  const isLeftThickFrameRequired =
    currentSelectedHeightOptionAttributes && currentSelectedHeightOptionAttributes.length > 0
      ? currentSelectedHeightOptionAttributes.find((attribute) => attribute.identifier === "thickFrame")
      : false;
  const isThickFrameRequired =
    selectedHeightAttributes && selectedHeightAttributes.length > 0
      ? selectedHeightAttributes.find((attribute) => attribute.identifier === "thickFrame")
      : false;
  const height = 1100;
  const width = Number(get(data, "data.width", 1900).match(/\d+/));
  const fieldsLength = get(data, "data.length", 2);
  const scaleFactor = get(data, "scaleFactor", 6);
  const securing = get(data, "data.securing", 0);
  const layers = get(data, "data.layers", []);
  const leftBullBar = get(data, "data.leftBullBar", "no_bullbar");
  const rightBullBar = get(data, "data.rightBullBar", "no_bullbar");
  const doubleShelf = get(data, "doubleShelf", false);
  const shelf = doubleShelf ? "double" : "single";
  const spacer = get(data, "distance", 200);
  const scaledHeight = height / scaleFactor;
  const scaledSpacer = spacer / scaleFactor;
  const scaledWidth = width === 1900 ? width / scaleFactor + 8 : width / scaleFactor;
  const classes = useStyles({ scaleFactor });
  const bullBarHeightwithSpacer = scaledHeight * 2 + scaledSpacer;
  const bullBarHeight = doubleShelf ? bullBarHeightwithSpacer + 64 / scaleFactor : bullBarHeightwithSpacer;
  let floors = [];
  for (let i = layers.length - 1; i >= 0; i--) {
    const layerShelfBottom = layers[i] ? layers[i].floor : "frontend_noBottom";
    const shelfBottomImage = layerShelfBottom.includes("grating")
      ? "grate"
      : layerShelfBottom.includes("noBottom")
      ? "nobottom"
      : layerShelfBottom.includes("chipboard")
      ? "chipboard"
      : "steel";
    layerShelfBottom !== "frontend_noBottom" &&
      floors.push(
        <div
          className={classes.floor}
          style={{
            width: scaledWidth,
            minHeight: scaledHeight,
            backgroundImage: `url(${baseUrl}/images/item/artus/image/topview/shelfbottom_${shelfBottomImage}_width_${width}.svg)`,
            backgroundSize: "cover",
          }}
        ></div>
      );
  }
  return (
    <div className={classes.container}>
      {doubleShelf && (
        <>
          <div className={clsx(classes.flexCol, id !== 1 && "spacing")}>
            {id === 1 && (
              <>
                <img
                  src={`${baseUrl}/images/item/artus/image/topview/frame_${
                    isLeftThickFrameRequired ? "thick" : "thin"
                  }_bottomlayer.svg`}
                  className={clsx(classes.leftFrame, "bottomLayer")}
                  style={{ maxHeight: scaledHeight }}
                />
                <img
                  src={`${baseUrl}/images/item/artus/image/topview/frame_${
                    isLeftThickFrameRequired ? "thick" : "thin"
                  }_toplayer.svg`}
                  className={classes.leftFrame}
                  style={{ maxHeight: scaledHeight }}
                />
              </>
            )}
            <div
              style={{
                minHeight: scaledHeight,
                maxHeight: scaledHeight,
                minWidth: scaledWidth,
                width: scaledWidth,
              }}
            >
              {floors}
              <div
                className={classes.barImage}
                style={{
                  maxWidth: scaledWidth,
                  minHeight: scaledHeight,
                  backgroundImage: `url(${baseUrl}/images/item/artus/image/topview/supportbar_width_${width}.svg)`,
                  backgroundSize: "cover",
                }}
              ></div>
            </div>
            <img
              src={`${baseUrl}/images/item/artus/image/topview/frame_${
                isThickFrameRequired ? "thick" : "thin"
              }_bottomlayer.svg`}
              className={clsx(classes.rightFrame, "bottomLayer")}
              style={{ height: scaledHeight }}
            />
            <img
              src={`${baseUrl}/images/item/artus/image/topview/frame_${
                isThickFrameRequired ? "thick" : "thin"
              }_toplayer.svg`}
              className={classes.rightFrame}
              style={{ height: scaledHeight }}
            />
          </div>
          <div className={clsx(classes.flexCol, id !== 1 && "spacing")}>
            <div style={{ height: scaledSpacer, width: "100%" }}>
              {id === 1 && (
                <div
                  style={{
                    backgroundImage: `url(${baseUrl}/images/item/artus/image/topview/spacer_depth_${spacer}.svg)`,
                    height: scaledSpacer,
                    width: 4,
                    position: "absolute",
                    left: 56 / scaleFactor,
                  }}
                ></div>
              )}
              <div
                style={{
                  backgroundImage: `url(${baseUrl}/images/item/artus/image/topview/spacer_depth_${spacer}.svg)`,
                  height: scaledSpacer,
                  position: "absolute",
                  width: 4,
                  right: 40 / scaleFactor,
                }}
              ></div>
            </div>
          </div>
        </>
      )}
      <div className={clsx(classes.flexCol, id !== 1 && "spacing")}>
        {id === 1 && (
          <>
            <img
              src={`${baseUrl}/images/item/artus/image/topview/frame_${
                isLeftThickFrameRequired ? "thick" : "thin"
              }_bottomlayer.svg`}
              className={clsx(classes.leftFrame, "bottomLayer")}
              style={{ maxHeight: scaledHeight }}
            />
            <img
              src={`${baseUrl}/images/item/artus/image/topview/frame_${
                isLeftThickFrameRequired ? "thick" : "thin"
              }_toplayer.svg`}
              className={classes.leftFrame}
              style={{ maxHeight: scaledHeight }}
            />
          </>
        )}
        {leftBullBar !== "no_bullbar" && (
          <img
            src={`${baseUrl}/images/item/artus/image/topview/bullbar_${leftBullBar}${
              id === 1 ? "_left" : ""
            }_${leftBullBar.includes("single") && doubleShelf ? "single" : shelf}rack.svg`}
            style={{ height: bullBarHeight }}
            className={id === 1 ? classes.leftBullBar : classes.centerBullBar}
          />
        )}
        {rightBullBar !== "no_bullbar" && id === fieldsLength && (
          <img
            src={`${baseUrl}/images/item/artus/image/topview/bullbar_${rightBullBar}_right_${
              rightBullBar.includes("single") && doubleShelf ? "single" : shelf
            }rack.svg`}
            style={{ height: bullBarHeight }}
            className={classes.rightBullBar}
          />
        )}
        <div
          style={{
            minHeight: scaledHeight,
            maxHeight: scaledHeight,
            minWidth: scaledWidth,
            width: scaledWidth,
          }}
        >
          {floors}
          {securing &&
            securing !== "frontend_noSecuring" &&
            (securing.includes("Grating") ? (
              <img
                className={classes.securingBar}
                style={{ maxWidth: scaledWidth }}
                src={`${baseUrl}/images/item/artus/image/topview/securing_mesh_width_${width}.svg`}
              />
            ) : (
              <img
                className={classes.securingBar}
                style={{ maxWidth: scaledWidth - 16 / scaleFactor, left: 16 / scaleFactor }}
                src={`${baseUrl}/images/item/artus/image/topview/securing_bar_width_${width}.svg`}
              />
            ))}
          <div
            className={classes.barImage}
            style={{
              maxWidth: scaledWidth,
              minHeight: scaledHeight,
              backgroundImage: `url(${baseUrl}/images/item/artus/image/topview/supportbar_width_${width}.svg)`,
              backgroundSize: "cover",
            }}
          ></div>
        </div>

        <img
          src={`${baseUrl}/images/item/artus/image/topview/frame_${
            isThickFrameRequired ? "thick" : "thin"
          }_bottomlayer.svg`}
          className={clsx(classes.rightFrame, "bottomLayer")}
          style={{ height: scaledHeight }}
        />
        <img
          src={`${baseUrl}/images/item/artus/image/topview/frame_${
            isThickFrameRequired ? "thick" : "thin"
          }_toplayer.svg`}
          className={classes.rightFrame}
          style={{ height: scaledHeight }}
        />
      </div>
    </div>
  );
};
TopView2D.whyDidYouRender = true;
export default TopView2D;
